import { AppEnvironment } from 'projects/config/model/environment.model';

export type KnowledgeCenterLinkGateEnvironment = Pick<AppEnvironment, 'isDEV' | 'isQA' | 'isRC'>;

export function isKnowledgeCenterHeaderLinkEnabled(env: KnowledgeCenterLinkGateEnvironment): boolean {
  return env.isDEV || env.isQA || env.isRC;
}
